import React from "react"

const Prose = ({children}) => (
    <article className="prose prose-lg max-w-none prose-green dark:prose-invert">
        {children}
    </article>
)

export default Prose